const StripeKeys = { 'stripePublicKey': process.env.REACT_APP_STRIPE_PUBLIC_KEY || '' }

export default StripeKeys;
